(function () {
  function initCarousels(root) {
    root.querySelectorAll('[data-peri-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-peri-carousel-track]');
      var prev = carousel.querySelector('[data-peri-carousel-prev]');
      var next = carousel.querySelector('[data-peri-carousel-next]');
      if (!track) return;

      var scrollBy = function (dir) {
        var card = track.querySelector('[data-peri-carousel-item]');
        var amount = card ? card.offsetWidth + 16 : 316;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };

      if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
      if (next) next.addEventListener('click', function () { scrollBy(1); });
    });
  }

  function initTestimonialsMarquee(root) {
    root.querySelectorAll('.peri-pdp-testimonials__marquee').forEach(function (marquee) {
      var track = marquee.querySelector('.peri-pdp-testimonials__track');
      if (!track || track._periMarqueeBound) return;
      track._periMarqueeBound = true;

      function resetToStart() {
        // Scrollable fallback (prefers-reduced-motion)
        try { marquee.scrollLeft = 0; } catch (err) {}

        // Restart CSS loop so the first card is always on-screen when this
        // section enters view (avoids mid-animation blank on the left).
        track.classList.add('is-paused');
        track.style.animation = 'none';
        void track.offsetWidth;
        track.style.animation = '';
        track.classList.remove('is-paused');
      }

      // Pause until visible — prevents off-screen drift before the user arrives.
      track.classList.add('is-paused');

      if (typeof IntersectionObserver !== 'function') {
        resetToStart();
        return;
      }

      var wasVisible = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!wasVisible) resetToStart();
            wasVisible = true;
          } else if (entry.intersectionRatio === 0) {
            wasVisible = false;
            track.classList.add('is-paused');
          }
        });
      }, { threshold: [0, 0.2] });

      observer.observe(marquee);
    });
  }

  function hasJoinedVip() {
    try {
      return sessionStorage.getItem('periVipJoined') === '1';
    } catch (err) {
      return false;
    }
  }

  function openWaitlistModal() {
    var modal = document.querySelector('[data-peri-waitlist]');
    if (!modal || typeof modal._periWaitlistOpen !== 'function') return false;
    if (hasJoinedVip()) return false;
    modal._periWaitlistOpen();
    return true;
  }

  function initAtcLinks(root) {
    root.querySelectorAll('[data-peri-atc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (openWaitlistModal()) {
          e.preventDefault();
          return;
        }
        var target = document.getElementById('peri-hero-atc');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var submit = document.querySelector('[data-peri-hero-submit]');
        if (submit && !submit.disabled) submit.focus();
      });
    });
  }

  function initWaitlistModal() {
    var modal = document.querySelector('[data-peri-waitlist]');
    if (!modal) return;

    var overlay = modal.querySelector('[data-peri-waitlist-overlay]');
    var closeBtns = modal.querySelectorAll('[data-peri-waitlist-close]');
    var form = modal.querySelector('[data-peri-waitlist-form]');
    var field = modal.querySelector('[data-peri-waitlist-field]');
    var formPanel = modal.querySelector('[data-peri-waitlist-form-panel]');
    var successPanel = modal.querySelector('[data-peri-waitlist-success-panel]');
    var errorIcon = modal.querySelector('[data-peri-waitlist-error-icon]');
    var submitBtn = modal.querySelector('[data-peri-waitlist-submit]');
    var listId = modal.getAttribute('data-klaviyo-list') || 'Xkuqnz';
    var lastFocus = null;
    var onceKey = 'periVipEarlyAccessShown';
    var emailInput = form ? form.querySelector('[name="email"]') : null;
    var defaultPlaceholder = (emailInput && emailInput.getAttribute('data-default-placeholder')) || 'you@email.com';

    function clearError() {
      if (field) field.classList.remove('is-error');
      if (errorIcon) errorIcon.hidden = true;
      if (emailInput) {
        emailInput.removeAttribute('aria-invalid');
        emailInput.placeholder = defaultPlaceholder;
      }
    }

    function showError() {
      if (field) field.classList.add('is-error');
      if (errorIcon) errorIcon.hidden = false;
      if (emailInput) {
        emailInput.value = '';
        emailInput.placeholder = 'Enter a valid email';
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
      }
    }

    function showForm() {
      if (formPanel) formPanel.hidden = false;
      if (successPanel) successPanel.hidden = true;
      clearError();
      if (form) form.reset();
      if (emailInput) emailInput.placeholder = defaultPlaceholder;
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
      }
    }

    function showSuccess() {
      if (formPanel) formPanel.hidden = true;
      if (successPanel) successPanel.hidden = false;
      clearError();
      markVipSuccess();
      setTimeout(close, 600);
    }

    function open() {
      // Registered users should never see the waitlist popup again.
      if (hasJoinedVip()) return false;
      if (!modal.hidden) return false;
      lastFocus = document.activeElement;
      showForm();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('peri-waitlist-open');
      var firstInput = modal.querySelector('input');
      if (firstInput) firstInput.focus();
      else if (closeBtns.length) closeBtns[0].focus();
      return true;
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('peri-waitlist-open');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    }

    function markShownOnce() {
      if (modal.getAttribute('data-peri-waitlist-once') !== '1') return;
      try { sessionStorage.setItem(onceKey, '1'); } catch (err) {}
    }

    function alreadyShownOnce() {
      if (modal.getAttribute('data-peri-waitlist-once') !== '1') return false;
      try {
        return !!sessionStorage.getItem(onceKey);
      } catch (err) {
        return false;
      }
    }

    modal._periWaitlistOpen = open;
    modal._periWaitlistClose = close;

    if (overlay) overlay.addEventListener('click', close);
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    // PDP: open once after coaches trust section is reached / scrolled past
    if (modal.hasAttribute('data-peri-waitlist-after-trust')) {
      var trust = document.querySelector('[data-peri-coaches-trust]') ||
        document.querySelector('.peri-pdp-coaches__trust');
      if (trust) {
        var trustFired = false;

        function openAfterTrust() {
          if (trustFired || hasJoinedVip() || alreadyShownOnce() || !modal.hidden) return;
          trustFired = true;
          markShownOnce();
          window.removeEventListener('scroll', checkTrustTrigger);
          if (trustObserver) trustObserver.disconnect();
          setTimeout(open, 350);
        }

        function checkTrustTrigger() {
          if (trustFired || hasJoinedVip() || alreadyShownOnce()) return;
          var rect = trust.getBoundingClientRect();
          var vh = window.innerHeight || 0;
          // Fire once trust has entered the upper half of the viewport
          // (user has reached the coaches trust block).
          if (rect.top <= vh * 0.55 && rect.bottom > 40) {
            openAfterTrust();
          }
        }

        var trustObserver = null;
        if ('IntersectionObserver' in window) {
          trustObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              openAfterTrust();
            });
          }, { threshold: 0.15, rootMargin: '0px 0px -20% 0px' });
          trustObserver.observe(trust);
        }

        window.addEventListener('scroll', checkTrustTrigger, { passive: true });
        checkTrustTrigger();
      }
    }

    // Article pages: open once at configured scroll depth
    var scrollAttr = modal.getAttribute('data-peri-waitlist-scroll');
    var scrollPercent = scrollAttr ? parseInt(scrollAttr, 10) : 0;
    if (scrollPercent > 0 && scrollPercent <= 100) {
      var scrollFired = false;

      function maybeOpenOnScroll() {
        if (scrollFired) return;
        if (hasJoinedVip() || alreadyShownOnce()) return;
        var doc = document.documentElement;
        var body = document.body;
        var scrollHeight = Math.max(
          doc ? doc.scrollHeight : 0,
          body ? body.scrollHeight : 0
        );
        if (!scrollHeight) return;
        var scrolled = (window.scrollY || window.pageYOffset || 0) + (window.innerHeight || 0);
        if (scrolled / scrollHeight < scrollPercent / 100) return;

        scrollFired = true;
        window.removeEventListener('scroll', maybeOpenOnScroll);
        markShownOnce();
        open();
      }

      window.addEventListener('scroll', maybeOpenOnScroll, { passive: true });
      maybeOpenOnScroll();
    }

    if (emailInput) {
      emailInput.addEventListener('input', clearError);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        var email = emailInput ? String(emailInput.value || '').trim() : '';

        if (!email || email.indexOf('@') === -1) {
          showError();
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        subscribeVipEmail(email, listId, 'Perimenopause VIP Popup')
          .then(showSuccess)
          .catch(showSuccess)
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          });
      });
    }
  }

  function subscribeVipEmail(email, listId, source) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { $email: email }]);
    } catch (err) {}

    var formData = new FormData();
    formData.append('g', listId || 'Xkuqnz');
    formData.append('email', email);
    formData.append('$source', source || 'Perimenopause VIP');
    formData.append('$consent', 'web');

    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      body: formData,
      mode: 'no-cors'
    });
  }

  function markVipSuccess() {
    var heroRoot = document.querySelector('[data-peri-hero-vip]');
    if (heroRoot) {
      var heroForm = heroRoot.querySelector('[data-peri-hero-vip-form]');
      var heroField = heroRoot.querySelector('[data-peri-hero-vip-field]');
      var heroErrorIcon = heroRoot.querySelector('[data-peri-hero-vip-error-icon]');
      var heroSuccess = heroRoot.querySelector('[data-peri-hero-vip-success]');
      if (heroForm) heroForm.hidden = true;
      if (heroField) heroField.classList.remove('is-error');
      if (heroErrorIcon) heroErrorIcon.hidden = true;
      if (heroSuccess) heroSuccess.hidden = false;
      heroRoot.classList.add('is-success');
    }

    var sticky = document.querySelector('[data-peri-sticky]');
    if (sticky) {
      var stickyField = sticky.querySelector('[data-peri-sticky-field]');
      var stickyErrorIcon = sticky.querySelector('[data-peri-sticky-error-icon]');
      var stickyCompact = sticky.querySelector('[data-peri-sticky-success]');
      if (stickyField) stickyField.classList.remove('is-error');
      if (stickyErrorIcon) stickyErrorIcon.hidden = true;
      // Unlock teaser is a sticky collapse state — not VIP join success.
      // After join, hide sticky entirely (hero/capture show real success).
      if (stickyCompact) stickyCompact.hidden = true;
      sticky.classList.add('is-success');
      sticky.classList.add('peri-pdp-sticky--hidden');
      sticky.setAttribute('aria-hidden', 'true');
    }

    var vipCapture = document.querySelector('[data-peri-vip-capture]');
    if (vipCapture) {
      var captureForm = vipCapture.querySelector('[data-peri-vip-capture-form]');
      var captureSuccess = vipCapture.querySelector('[data-peri-vip-capture-success]');
      if (captureForm) captureForm.hidden = true;
      if (captureSuccess) captureSuccess.hidden = false;
      vipCapture.classList.add('is-success');
    }

    try {
      sessionStorage.setItem('periVipJoined', '1');
    } catch (err) {}
  }

  function initHeroVipForm() {
    var root = document.querySelector('[data-peri-hero-vip]');
    if (!root) return;

    var form = root.querySelector('[data-peri-hero-vip-form]');
    var field = root.querySelector('[data-peri-hero-vip-field]');
    var submitBtn = root.querySelector('[data-peri-hero-vip-submit]');
    var errorIcon = root.querySelector('[data-peri-hero-vip-error-icon]');
    var listId = root.getAttribute('data-klaviyo-list') || 'Xkuqnz';
    if (!form) return;

    var emailInput = form.querySelector('[name="email"]');
    var defaultPlaceholder = (emailInput && emailInput.getAttribute('data-default-placeholder')) || 'you@email.com';

    function clearError() {
      if (field) field.classList.remove('is-error');
      if (errorIcon) errorIcon.hidden = true;
      if (emailInput) {
        emailInput.removeAttribute('aria-invalid');
        emailInput.placeholder = defaultPlaceholder;
      }
    }

    function showError() {
      if (field) field.classList.add('is-error');
      if (errorIcon) errorIcon.hidden = false;
      if (emailInput) {
        emailInput.value = '';
        emailInput.placeholder = 'Enter a valid email';
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
      }
    }

    if (emailInput) {
      emailInput.addEventListener('input', clearError);
      emailInput.addEventListener('focus', function () {
        if (field && field.classList.contains('is-error') && !String(emailInput.value || '').trim()) {
          // Keep error chrome until user types; restore default placeholder on first keystroke via input
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var email = emailInput ? String(emailInput.value || '').trim() : '';
      if (!email || email.indexOf('@') === -1) {
        showError();
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }

      subscribeVipEmail(email, listId, 'Perimenopause Hero VIP')
        .then(markVipSuccess)
        .catch(markVipSuccess)
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        });
    });
  }

  function initStickyCta() {
    var sticky = document.querySelector('[data-peri-sticky]');
    if (!sticky) return;

    var anchor = document.querySelector('[data-peri-hero-cta-anchor]');
    // Prefer the inner hero section (excludes the sticky, which Shopify wraps
    // in the same .peri-section-hero shopify-section as the hero markup).
    var heroSection =
      document.querySelector('.peri-pdp-hero') ||
      document.querySelector('[id*="__peri_hero"] .peri-pdp-hero') ||
      document.querySelector('.peri-section-hero') ||
      (anchor && anchor.closest('.shopify-section')) ||
      document.querySelector('[id*="__peri_hero"]');

    var form = sticky.querySelector('[data-peri-sticky-form]');
    var field = sticky.querySelector('[data-peri-sticky-field]');
    var submitBtn = sticky.querySelector('[data-peri-sticky-submit]');
    var errorIcon = sticky.querySelector('[data-peri-sticky-error-icon]');
    var toggleBtn = sticky.querySelector('[data-peri-sticky-toggle]');
    var toggleDown = sticky.querySelector('.peri-pdp-sticky__toggle-icon--down');
    var toggleUp = sticky.querySelector('.peri-pdp-sticky__toggle-icon--up');
    var heroVip = document.querySelector('[data-peri-hero-vip]');
    var vipCapture = document.querySelector('[data-peri-vip-capture]');
    var listId = (heroVip && heroVip.getAttribute('data-klaviyo-list')) || 'Xkuqnz';
    var footers = Array.prototype.slice.call(
      document.querySelectorAll('footer, [id*="__core-footer"]')
    );
    var emailInput = form ? form.querySelector('[name="email"]') : null;
    var defaultPlaceholder = (emailInput && emailInput.getAttribute('data-default-placeholder')) || 'you@email.com';
    var collapseKey = 'periStickyCollapsed';

    var heroInView = true;
    var vipCaptureInView = false;
    var firstGlanceDismissed = false;
    var FIRST_GLANCE_SCROLL_PX = 48;

    function isElementInView(el) {
      if (!el || !el.isConnected) return false;
      var viewportH = window.innerHeight || 0;
      var rect = el.getBoundingClientRect();
      return rect.top < viewportH && rect.bottom > 0;
    }

    function isFooterInView() {
      for (var i = 0; i < footers.length; i++) {
        var el = footers[i];
        if (!el || !el.isConnected) continue;
        if (el.offsetHeight === 0 && !el.getClientRects().length) continue;
        if (isElementInView(el)) return true;
      }
      return false;
    }

    function setCollapsed(collapsed) {
      sticky.classList.toggle('is-collapsed', collapsed);

      // Collapsed = unlock teaser (16899); expanded = VIP form (15628)
      var compactEl = sticky.querySelector('[data-peri-sticky-success]');
      if (compactEl) compactEl.hidden = !collapsed;
      if (form) form.hidden = !!collapsed;

      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        toggleBtn.setAttribute(
          'aria-label',
          collapsed ? 'Expand VIP offer' : 'Minimize VIP offer'
        );
      }
      // Up = collapsed (16898); down = expanded (16456)
      if (toggleDown) toggleDown.hidden = collapsed;
      if (toggleUp) toggleUp.hidden = !collapsed;
      try {
        if (collapsed) sessionStorage.setItem(collapseKey, '1');
        else sessionStorage.removeItem(collapseKey);
      } catch (err) {}
    }

    function syncStickyVisibility() {
      // VIP join success lives on hero/capture — sticky should not appear after join.
      if (sticky.classList.contains('is-success')) {
        sticky.classList.add('peri-pdp-sticky--hidden');
        sticky.setAttribute('aria-hidden', 'true');
        return;
      }

      var scrollY = window.scrollY || window.pageYOffset || 0;

      // First glance: show sticky at top of page; hide once the user scrolls,
      // then resume the normal past-hero / vip-capture / footer rules.
      if (scrollY > FIRST_GLANCE_SCROLL_PX) {
        firstGlanceDismissed = true;
      } else if (scrollY <= 8) {
        firstGlanceDismissed = false;
      }

      var atFirstGlance = !firstGlanceDismissed && scrollY <= FIRST_GLANCE_SCROLL_PX;
      var midPageVisible = !heroInView && !vipCaptureInView && !isFooterInView();
      var visible = atFirstGlance || midPageVisible;

      sticky.classList.toggle('peri-pdp-sticky--hidden', !visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        setCollapsed(!sticky.classList.contains('is-collapsed'));
      });
    }

    try {
      if (sessionStorage.getItem(collapseKey) === '1') setCollapsed(true);
      else setCollapsed(false);
    } catch (err) {
      setCollapsed(false);
    }

    function clearStickyError() {
      if (field) field.classList.remove('is-error');
      if (errorIcon) errorIcon.hidden = true;
      if (emailInput) {
        emailInput.removeAttribute('aria-invalid');
        emailInput.placeholder = defaultPlaceholder;
      }
    }

    function showStickyError() {
      if (field) field.classList.add('is-error');
      if (errorIcon) errorIcon.hidden = false;
      if (emailInput) {
        emailInput.value = '';
        emailInput.placeholder = 'Enter a valid email';
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
      }
    }

    if (emailInput) {
      emailInput.addEventListener('input', clearStickyError);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearStickyError();

        var email = emailInput ? String(emailInput.value || '').trim() : '';
        if (!email || email.indexOf('@') === -1) {
          showStickyError();
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        subscribeVipEmail(email, listId, 'Perimenopause Sticky VIP')
          .then(markVipSuccess)
          .catch(markVipSuccess)
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          });
      });
    }

    function updateHeroInView(rect, isIntersecting) {
      if (typeof isIntersecting === 'boolean') {
        heroInView = isIntersecting;
        return;
      }
      var viewportH = window.innerHeight || 0;
      heroInView = rect.bottom > 0 && rect.top < viewportH;
    }

    var heroObserveTarget = heroSection || anchor;
    if (typeof IntersectionObserver === 'function' && heroObserveTarget) {
      var heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          updateHeroInView(entry.boundingClientRect, entry.isIntersecting);
          syncStickyVisibility();
        });
      }, { threshold: 0, rootMargin: '0px' });

      heroObserver.observe(heroObserveTarget);

      if (vipCapture) {
        var vipObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            vipCaptureInView = entry.isIntersecting;
            syncStickyVisibility();
          });
        }, { threshold: 0, rootMargin: '0px' });
        vipObserver.observe(vipCapture);
      }

      if (footers.length) {
        var footerObserver = new IntersectionObserver(function () {
          syncStickyVisibility();
        }, { threshold: [0, 0.01, 0.1], rootMargin: '0px' });

        footers.forEach(function (el) {
          try { footerObserver.observe(el); } catch (e) {}
        });
      }
    }

    window.addEventListener('scroll', function () {
      if (heroObserveTarget) {
        try {
          updateHeroInView(heroObserveTarget.getBoundingClientRect());
        } catch (e) {}
      }
      if (vipCapture) vipCaptureInView = isElementInView(vipCapture);
      syncStickyVisibility();
    }, { passive: true });
    window.addEventListener('resize', syncStickyVisibility, { passive: true });

    try {
      if (heroObserveTarget) updateHeroInView(heroObserveTarget.getBoundingClientRect());
      if (vipCapture) vipCaptureInView = isElementInView(vipCapture);
    } catch (e) {}

    try {
      if (sessionStorage.getItem('periVipJoined') === '1') {
        markVipSuccess();
      }
    } catch (err) {}

    syncStickyVisibility();
  }

  function initVipCapture() {
    var root = document.querySelector('[data-peri-vip-capture]');
    if (!root) return;

    var form = root.querySelector('[data-peri-vip-capture-form]');
    var field = root.querySelector('[data-peri-vip-capture-field]');
    var submitBtn = root.querySelector('[data-peri-vip-capture-submit]');
    var errorIcon = root.querySelector('[data-peri-vip-capture-error-icon]');
    var successEl = root.querySelector('[data-peri-vip-capture-success]');
    var listId = root.getAttribute('data-klaviyo-list') || 'Xkuqnz';
    var countdown = root.querySelector('[data-peri-vip-countdown]');
    var emailInput = form ? form.querySelector('[name="email"]') : null;
    var defaultPlaceholder = (emailInput && emailInput.getAttribute('data-default-placeholder')) || 'you@email.com';

    function clearError() {
      if (field) field.classList.remove('is-error');
      if (errorIcon) errorIcon.hidden = true;
      if (emailInput) {
        emailInput.removeAttribute('aria-invalid');
        emailInput.placeholder = defaultPlaceholder;
      }
    }

    function showError() {
      if (field) field.classList.add('is-error');
      if (errorIcon) errorIcon.hidden = false;
      if (emailInput) {
        emailInput.value = '';
        emailInput.placeholder = 'Enter a valid email';
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
      }
    }

    function showSuccess() {
      if (form) form.hidden = true;
      clearError();
      if (successEl) successEl.hidden = false;
      root.classList.add('is-success');
      markVipSuccess();
    }

    if (emailInput) {
      emailInput.addEventListener('input', clearError);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        var email = emailInput ? String(emailInput.value || '').trim() : '';
        if (!email || email.indexOf('@') === -1) {
          showError();
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        subscribeVipEmail(email, listId, 'Perimenopause VIP Capture')
          .then(showSuccess)
          .catch(showSuccess)
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          });
      });
    }

    if (countdown) {
      var endAttr = countdown.getAttribute('data-end') || '';
      var endMs = Date.parse(endAttr);
      var daysEl = countdown.querySelector('[data-days]');
      var hoursEl = countdown.querySelector('[data-hours]');
      var minsEl = countdown.querySelector('[data-mins]');
      var secsEl = countdown.querySelector('[data-secs]');

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var now = Date.now();
        var diff = isNaN(endMs) ? 0 : Math.max(0, endMs - now);
        var totalSec = Math.floor(diff / 1000);
        var days = Math.floor(totalSec / 86400);
        var hours = Math.floor((totalSec % 86400) / 3600);
        var mins = Math.floor((totalSec % 3600) / 60);
        var secs = totalSec % 60;
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minsEl) minsEl.textContent = pad(mins);
        if (secsEl) secsEl.textContent = pad(secs);
      }

      tick();
      setInterval(tick, 1000);
    }
  }

  function init() {
    if (window.__periPdpInitialized) return;
    window.__periPdpInitialized = true;

    initCarousels(document);
    initTestimonialsMarquee(document);
    initWaitlistModal();
    initHeroVipForm();
    initVipCapture();
    initAtcLinks(document);
    initStickyCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
